


































































































import Vue from "vue";
import ElementUI from "element-ui";
import * as api from "@/api";
import MainSearch from "../Search.vue";
import HeaderVs from "./HeaderVs.vue";
import HeaderNews from "./HeaderNews.vue";

export default Vue.extend({
    components: {
        MainSearch,
        HeaderVs,
        HeaderNews
    },
    data() {
        return {
            nav: [
                {
                    id: 1,
                    name: "标准数据库",
                    path: "/products",
                    childPath: null
                },
                {
                    id: 2,
                    name: "定制仿真",
                    path: "/customSimulation",
                    childPath: ["/simulationHomePage"]
                },
                {
                    id: 3,
                    // 智能评价  作业
                    name: "智能评价",
                    path: "/home-work",
                    childPath: ["/task-file"]
                },

                {
                    id: 4,
                    name: "教学资源",
                    path: "/teachResource",
                    childPath: null
                },
                // {
                //     id: 5,
                //     name: '工具库',
                //     path: '/bimtool',
                //     childPath: null,
                // },
                // {
                //     id: 6,
                //     name: '关于制造商',
                //     path: '/about-manufacturer',
                //     childPath: null,
                // },
                {
                    id: 5,
                    name: "关于我们",
                    path: "/about",
                    childPath: null
                }
            ]
        };
    },
    computed: {
        unreadCount() {
            return this.$store.state.unreadCount;
        },
        user() {
            return this.$store.state.user;
        },
        compareListCount(): number {
            return this.$store.state.compareProductList.length;
        },
        searchKeyword: {
            get(): string {
                return this.$store.state.searchKeyword;
            },
            set(val) {
                this.$store.commit("searchKeyword", val);
            }
        }
    },
    watch: {
        user: {
            handler(val) {
                if (val) {
                    this.$store.dispatch("getUnreadCount");
                    this.$store.dispatch("getProductCompareList");
                }
            },
            immediate: true
        }
    },
    methods: {
        async getUnreadCount() {
            const res = await api.getUnreadCount();
            if (!api.error(res)) {
                this.unreadCount = res.data;
            }
        },
        login() {
            this.$store.commit("loginVisible", true);
        },
        logout() {
            this.$store.commit("logout");
            window.location.reload();
        },
        search() {
            this.$router.push({
                path: "/search-results",
                query: {
                    keyword: this.searchKeyword as string
                }
            });
            (this.$refs.search as ElementUI.Input).blur();
        }
    }
});
